<template lang="pug">
div
  div(v-if='block.value !== ""')
    youtube(:video-id='block.value', player-width='100%')
  div
    v-btn(@click.stop='dialog = true', small, flat)
      v-icon(left) add
      | Добавить
  v-dialog(v-model='dialog', max-width='300px')
    v-card
      v-container(grid-list-xl)
        v-layout(wrap)
          v-flex(xs12)
            v-text-field(v-model='video', label='Видео id youtube')
      v-card-actions
        v-spacer
        v-btn(flat, @click='undo') Отмена
        v-btn(flat, color='primary', @click='save') Сохранить
</template>

<script>
import Vue from 'vue'
import VueYouTubeEmbed from 'vue-youtube-embed'
import BaseBlock from './BaseBlock'

Vue.use(VueYouTubeEmbed, { global: true, componentId: 'youtube' })

export default {
  extends: BaseBlock,

  data: () => ({
    dialog: false,
    video: '',
  }),

  methods: {
    save() {
      this.block.value = this.video
      this.dialog = false
      this.$emit('update', this.block)
    },

    undo() {
      this.dialog = false
      this.video = ''
    },
  },
}
</script>
